import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {
  Badge,
  CrossSolidIcon,
  Heading,
  TickCircleIcon,
} from '@edume/magnificent';

import {avatarFromName} from '../../../utils/managerInsightUtils';

import styles from './styles.module.scss';

function ContentDetailCard({name, isCompleted, isInSearch}) {
  return (
    <div styleName='content-detail-card'>
      <div styleName='content-detail-card-avatar'>
        <Heading
          as='h2'
          colour='white'
          size='hamster'
          textTransform='none'
          weight='semiBold'
        >
          {avatarFromName(name || '')}
        </Heading>
      </div>
      <div>
        <Heading
          as='h2'
          colour='textPrimary'
          size='hamster'
          textTransform='none'
          weight='semiBold'
        >
          {name}
        </Heading>
      </div>

      <div styleName='badge'>
        {isInSearch &&
          (isCompleted ? (
            <Badge
              badgeStyle='default'
              colour='green'
              compact
              textContent={
                <span styleName='badge-inner'>
                  <TickCircleIcon colour='successPrimary' />
                  Completed
                </span>
              }
            />
          ) : (
            <Badge
              badgeStyle='default'
              colour='red'
              compact
              textContent={
                <span styleName='badge-inner'>
                  <CrossSolidIcon colour='errorPrimary' />
                  Not completed
                </span>
              }
            />
          ))}
      </div>
    </div>
  );
}

ContentDetailCard.propTypes = {
  name: PropTypes.string.isRequired,
  isCompleted: PropTypes.bool,
  isInSearch: PropTypes.bool,
};

export default CSSModules(ContentDetailCard, styles, {allowMultiple: true});
